import { SxProps, Theme } from '@mui/system';

export default {
  counterCard: {
    position: 'relative',
  },

  counterOfferCard: {
    position: 'absolute',
    right: 15,
    borderRadius: '0px 0px 5.762px 5.762px',
    zIndex: 100,
    width: '72.981px',
    height: '17.875px',
    backgroundColor: 'common.counterRed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  counterOfferCardText: {
    fontSize: '9px',
    fontWeight: 600,
    textAlign: 'center',
    color: 'white',
  },

} satisfies Record<string, SxProps<Theme>>;
